import React, { createContext, useContext } from "react"
import { db } from "../api/firebase/firebaseConfig";

const DbContext = createContext()

export const useDb = () => useContext(DbContext)

export const DBProvider = ({ children }) => {
    const value = {
        db,
    }

    return (
        <DbContext.Provider value={value}>
            {children}
        </DbContext.Provider>
    )
}